define([
    "skylark-utils/query"
], function(query) {
    return query;
});
